
import { Component, Vue } from 'nuxt-property-decorator'
import Loader from '~/components/Loader.vue'

@Component({
  components: { Loader },
})
export default class AppModalState extends Vue {
}
